// temp variable to hold promise data
let data = false;

// fetch method to get manifest data
export default function MakeLoader({
    MANIFEST_PATH,
    FETCH_OPTIONS,
    DataDecorator = false
}) {
    return Object.freeze({
        fetchData,
        getRootPage,
        onRootPage,
        getPage,
        pageExists,
        getBreadcrumbs,
        navigateToHomePage,
        navigateToRoute,
        getRouteFromID,
        getMediaPath,

        get data() {
            return data;
        }
    })

    async function fetchData() {
        var path = MANIFEST_PATH;
        var globalFetchOptions = FETCH_OPTIONS || {};
        var localFetchOptions = {
            cache: "no-store"
        }
        var fetchOptions = Object.assign({}, localFetchOptions, globalFetchOptions);
        return new Promise((resolve, reject) => {
            fetch(path, fetchOptions).then(o => o.json())
                .then(o => {
                    data = DataDecorator ? DataDecorator(o) : o;
                    resolve();
                })
                .catch(e => {
                    console.log(e)
                    reject(e)
                })
        })
    }


    function getRootPage() {
        // HomePage is first page found without a parent
        // This means the first object in the "pages" array ie. data.pages[0].
        return data.pages.find(p => p.parent === null)
    }

    function onRootPage(){
        // hardcoded reference to '/future-spin', as it cant be referenced with content picker in umbraco
        return data.pages.find(p => p.parent === null).route === window.app.vm.$router.currentRoute._value.path || window.app.vm.$route.path == "/future-spin"
    }

    function navigateToHomePage() {
        return window.app.vm.$router.push(`/${app.manifest.getRootPage().slug}`)
    }

    function navigateToRoute(route) {
        return window.app.vm.$router.push(route)
    }


    function getPage(route) {

        // route: 'home/tunnel-boring-machine/bucket-wheel-excavator'
        // maybe there should be some check to see if the entire chain can be resolved ?
        // a naive solution could be to only check the page and parent and ignore the possibility of
        // multiple branches with the same slug names (in that case a more elaborate resolving alcho shoyuld be used.)

        let _route = getRoute(route);
        let fragments = route.replace(/:.*/, '').split('/').slice(-2)
        var result = {}

        if (fragments[0] === '') {
            result = data.pages.find(page => page.slug === _route)
        } else {
            // this is a sub route, lets find a page with the slug and parrent
            var [parent, slug] = fragments;
            result = data.pages.find(p => {
                return (p.parent == parent && p.slug == slug)
            })
        }

        return result ? result : getRootPage();
    }

    function pageExists(route) {
        let _route = getRoute(route);
        let fragments = _route.split('/').slice(-2)
        
        if (fragments.length === 1 && fragments[0] !== '') {
            return _route === fragments[0]
        } else {
            var [parent, slug] = fragments;
            var result = data.pages.find(p => {
                return (p.parent == parent && p.slug == slug)
            })
            return !!result
        }
    }

    function getRoute(route) {
        return route[0] === '/' ? route.substr(1) : route;
    }

    function getRouteFromID(id) {
        if(!id)
            return ''

        return data.pages.find(page => page.id === id).route
    }

    function getBreadcrumbs() {
        var breadcrumbs = [];
        var manifestPages = data.pages;
        var tempRoute = window.app.vm.$router.currentRoute._value.path.split("/").filter(el => el != '' || null)

        breadcrumbs = tempRoute.map(breadcrumb => {
            let page = manifestPages.find(page => page.slug === breadcrumb)
            return {
                title: page.title,
                slug: breadcrumb,
                route: page.route
            };
        })
        
        return breadcrumbs
    }

    function getMediaPath(url = '') {
        const mediaFolder = app.config.mediaFolder
    
        if (/http/.test(mediaFolder)) {
            const [protokol, host] = app.config.mediaFolder.split('//')
            return `${protokol}//` + `${host}/${url.replace(/(.*)\/media\//g, '')}`.replace(/\/{1,}/g, '/')
        } else {
            return `${mediaFolder}/${url.replace(/(.*)\/media\//g, '')}`.replace(/\/{1,}/g, '/')
        }
    }
}